// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YdQSq","filters":"styles_filters__IVElG","main":"styles_main__XXUNe"};